//新老数据替换 （通过cartId维度，逐一对比替换）
export let replaceData = (originalData, newData) => {
    originalData.forEach((store) => {
        newData.forEach((newStore) => {
            store.cartMixList.forEach((list) => {
                newStore.cartMixList.forEach((newList) => {
                    list.cartList.forEach((proList, proIndex) => {
                        newList.cartList.forEach((newProList) => {
                            //新老数据替换
                            if(newProList.product.cartId === proList.product.cartId){
                                //改状态
                                newProList.isChecked = proList.isChecked;
                                newProList.isDisabled = proList.isDisabled;

                                //替换
                                list.cartList.splice(proIndex, 1, newProList);
                            }
                        })
                    })    
                })
            })
        })
    })

    return originalData;
}